import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Note: installGlobalErrorHandler was removed — lazyWithRetry handles chunk failures
// and the ErrorBoundary is the final fallback. Having all three caused reload loops.

// Signal successful mount to boot watchdog
const signalBootSuccess = () => {
  if (typeof window !== 'undefined' && (window as any).__BOOT_SUCCESS) {
    console.log('[Boot] React mounted successfully');
    (window as any).__BOOT_SUCCESS();
  }
  // Clear stale recovery flags from previous error loops
  try {
    sessionStorage.removeItem('__gistgift_eb_module_reload');
    sessionStorage.removeItem('__gistgift_chunk_reload');
    localStorage.setItem('__gistgift_last_boot_ok', Date.now().toString());
  } catch (e) {
    // Ignore storage errors
  }
};

// Mount React and signal success
const root = createRoot(document.getElementById("root")!);
root.render(<App />);

// Signal boot success after initial render cycle
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    signalBootSuccess();
  });
});
